import { render, staticRenderFns } from "./LeaveCommentWasDeleted.vue?vue&type=template&id=b8c346e8"
import script from "./LeaveCommentWasDeleted.vue?vue&type=script&lang=js"
export * from "./LeaveCommentWasDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports